// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world
import wixPaidPlans from 'wix-paid-plans'; 
import wixUsers from 'wix-users';
import {has_tslof_course} from 'backend/utils';

$w.onReady( async function () {
	// Write your JavaScript here
	// $w('#quotesymbol').html = '<span style="font-size: 120px; color:#E4DE7B; font-family: Times New Roman, Times, serif;">&#8220;</span>';

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
	
	let user = wixUsers.currentUser;
	if ( user.loggedIn ) {
		
		let plans = await user.getPricingPlans();
		plans.forEach ( async (plan) => {
			if ( plan.name === "TSLOF Course" ) {
				let res = await $w("#coursebutton").show("slide", {"duration": 2000, "delay": 0, "direction": "bottom"});
			}
		});
		/**/
		if ( ! $w("#coursebutton").isVisible ) {
			let roles = await user.getRoles();
			roles.forEach ( async ( role ) => {
				if ( role.name === "Admin" || role.name === "TSLOF Course Free" ) { 
					let res = await $w("#coursebutton").show("slide", {"duration": 2000, "delay": 0, "direction": "bottom"});
				}	
			});	
		}
	} else {
		$w("#coursebutton").hide();
	}
	
});